import { ADMIN_API } from "./adminApi";
import { ApiOk, Paginated } from "./adminCommon.types";

export type AdminEnvioFilters = {
  page?: number;
  limit?: number;
  cliente_id?: string | number;
  carrier?: string;
  status?: string;
  pais?: string;
  date_from?: string;
  date_to?: string;
  search?: string;
};

export const listAdminEnvios = async (filters: AdminEnvioFilters = {}) => {
  const { data } = await ADMIN_API.get<Paginated<any>>("/api/admin/envios", { params: filters });
  return data;
};

export const getAdminEnvioDetail = async (id: string | number) => {
  const { data } = await ADMIN_API.get<ApiOk<any>>(`/api/admin/envios/${id}`);
  return data.data;
};

export const buscarEnvioPorRastreio = async (tracking: string) => {
  const { data } = await ADMIN_API.get<ApiOk<any[]>>(
    `/api/admin/envios/rastreio/${encodeURIComponent(tracking)}`
  );
  return data.data;
};

export type ReconciliacaoLinha = {
  tracking: string;
  encontrado: boolean;
  duplicado: boolean;
  clienteId: number | null;
  cliente: string | null;
  pedidoRef: string | null;
  carrier: string | null;
  status: string | null;
  valorUsd: number | null;
  valorBrl: number | null;
  data: string | null;
};

export type ReconciliacaoResumo = {
  clienteId: number;
  cliente: string | null;
  envios: number;
  totalUsd: number;
  valorBrl: number | null;
};

export type ReconciliacaoResultado = {
  linhas: ReconciliacaoLinha[];
  resumo: ReconciliacaoResumo[];
  totalInformados: number;
  totalEncontrados: number;
  dolar: number | null;
};

export const reconciliarRastreios = async (trackings: string[]) => {
  const { data } = await ADMIN_API.post<ApiOk<ReconciliacaoResultado>>("/api/admin/envios/reconciliar", {
    trackings,
  });
  return data.data;
};
